import React from 'react';
import './SavingsDebugPage.css';
import { ApiContext } from '../../../App';

const format = (num) => (num != null ? Number(num).toFixed(3) : "-");

const SummaryTable = ({ totals }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold mb-2">Totals Comparison</h2>
    <table className="energy-table">
      <thead>
        <tr>
          <th>Metric</th>
          <th>Actual</th>
          <th>Baseline</th>
          <th>Difference</th>
        </tr>
      </thead>
      <tbody>
        {Object.keys(totals.actual).map((key) => {
          const actual = totals.actual[key];
          const baseline = totals.baseline[key];
          return (
            <tr key={key}>
              <td>{key}</td>
              <td>{format(actual)}</td>
              <td>{format(baseline)}</td>
              <td>{format(baseline - actual)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

const BreakdownTable = ({ timestamps, actual, baseline }) => (
  <div className="breakdown-wrapper">
    <table className="energy-table">
      <thead>
        <tr>
          <th>Time</th>
          <th>Actual kWh</th>
          <th>Baseline kWh</th>
          <th>Δ kWh</th>
          <th>Actual Cost</th>
          <th>Baseline Cost</th>
          <th>Δ Cost</th>
          <th>Actual CO2</th>
          <th>Baseline CO2</th>
          <th>Δ CO2</th>
        </tr>
      </thead>
      <tbody>
        {timestamps.map((ts, i) => (
          <tr key={i}>
            <td>{new Date(ts).toLocaleTimeString()}</td>
            <td>{format(actual.kwh.breakdown[i] ?? 0)}</td>
            <td>{format(baseline.kwh.breakdown[i] ?? 0)}</td>
            <td>{format((baseline.kwh.breakdown[i] ?? 0) - (actual.kwh.breakdown[i] ?? 0))}</td>

            <td>{format(actual.cost.breakdown[i] ?? 0)}</td>
            <td>{format(baseline.cost.breakdown[i] ?? 0)}</td>
            <td>{format((baseline.cost.breakdown[i] ?? 0) - (actual.cost.breakdown[i] ?? 0))}</td>

            <td>{format(actual.co2.breakdown[i] ?? 0)}</td>
            <td>{format(baseline.co2.breakdown[i] ?? 0)}</td>
            <td>{format((baseline.co2.breakdown[i] ?? 0) - (actual.co2.breakdown[i] ?? 0))}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

function SavingsDebugReport({data}) {
  return (
<div className="energy-page">
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' }}>Savings Debug</h1>
      <SummaryTable totals={data.totals} />
      {data.breakdown.data.map((report, idx) => (
        <div key={idx} className="facility-card">
          <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '12px' }}>{report.facility_name || ` Hvac Id ${report.hvac_id}` || `Index ${idx + 1}`}</h2>
          <BreakdownTable
            timestamps={data.breakdown.timestamps}
            actual={report.actual}
            baseline={report.baseline}
          />
        </div>
      ))}
    </div>
  )
}

export default function SavingsDebugPage({dateParam, facility}) {
    const { hvacApi } = React.useContext(ApiContext);
    const [data, setData] = React.useState(null);

    React.useEffect(() => {
        if (facility) {
            hvacApi.getFacilityPerformanceBreakdown(
                facility,
                new Date(dateParam),
                data => {
                    setData(data);
                },
                () => {
                    window.alert("Couldn't retrieve data.");
                },
            );

        } else {
            hvacApi.getPerformanceBreakdown(
                new Date(dateParam),
                data => {
                    setData(data);
                },
                () => {
                    window.alert("Couldn't retrieve data.");
                },
            )
        }
    }, [hvacApi, dateParam, facility]);

    return ( data === null ? <div></div> :
      <SavingsDebugReport data={data}/>
    );
}
